module.exports = __webpack_public_path__ + "static/media/add_prod.950495de.svg";